import React, { Component } from 'react';
import styles from './CancelHelpLinkStyles';

export default class CancelHelpLink extends Component {
  render() {
    return (
      <div style={styles.textFieldHelpText}>Press ESC to <a style={styles.textFieldHelpTextLink} onClick={this.props.onClick}>Cancel</a>.</div>
    );
  }
}
